module.exports = __webpack_public_path__ + "img/Inktale_logo.003f5b57.png";